import Input from '@cashew/input';
import { api } from '@cashew/utils';
/* eslint-disable react/jsx-curly-brace-presence */
import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { BackArrow, Title } from '../../components';
import PageWithNavigation from '../../components/PageWithNavigation';

interface RouteParams {
  financePartnerId: string;
}

const PartnerDetails = () => {
  const { t } = useTranslation();
  const { token } = useSelector((state: any) => state.user);

  const [activeTab, setActiveTab] = useState('partner');
  const { financePartnerId } = useParams<RouteParams>();
  const [partnerData, setPartnerData] = useState<any>(null);

  useEffect(() => {
    if (financePartnerId) {
      api
        .get({
          endpoint: `finance-partner/${financePartnerId}`,
          headers: {
            Authorization: token,
          },
        })
        .then((resp: any) => {
          console.log(resp);

          setPartnerData(resp.data);
        })
        .catch((resp: any) => {
          console.error('Error fetching partner details:', resp);
        });
    }
  }, [financePartnerId]);

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <Helmet>
        <title>{t('orderDetails.sectionTitle')}</title>
      </Helmet>
      <PageWithNavigation>
        <div className="flex-row d-flex align-items-center justify-content-between">
          <Title>{partnerData?.name || 'Partner Details'}</Title>
          <BackArrow title={'Back to partners'} />
        </div>

        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'partner' ? 'active' : ''}`}
              onClick={() => handleTabClick('partner')}
            >
              Partner information
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'bank' ? 'active' : ''}`}
              onClick={() => handleTabClick('bank')}
            >
              Bank information
            </button>
          </li>
        </ul>

        <div className="p-0">
          {activeTab === 'partner' && (
            <div>
              {partnerData ? (
                <div className="container p-0 m-0">
                  <div className="row">
                    <h3 className="py-4 fw-bold">Partner Details</h3>
                    <div className="row">
                      <div className="mb-3 col-6">
                        <Input
                          label="Name"
                          name="name"
                          value={partnerData.name}
                          placeholder="Name"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <Input
                          label="Phone Number"
                          name="phoneNumber"
                          value={partnerData.phoneNumber}
                          placeholder="Phone Number"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <Input
                          label="Email"
                          name="email"
                          value={partnerData.email}
                          placeholder="Email"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <Input
                          label="Address"
                          name="address"
                          value={partnerData.address}
                          placeholder="Address"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <Input
                          label="Tax Registration Number"
                          name="taxRegistrationNumber"
                          value={partnerData.taxRegistrationNumber}
                          placeholder="Tax Registration Number"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <Input
                          label="Country"
                          name="country"
                          value={partnerData.country}
                          placeholder="Country"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <Input
                          label="Cycle Period"
                          name="cyclePeriod"
                          value={partnerData.cyclePeriod}
                          placeholder="Cycle Period"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <Input
                          label="Status"
                          name="status"
                          value={partnerData.status}
                          placeholder="Status"
                          readonly
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-6">
                        <Input
                          label="Brand Name"
                          name="brandName"
                          value={partnerData.brandName}
                          placeholder="Brand Name"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <Input
                          label="Registration Date"
                          name="registrationDate"
                          value={partnerData.registrationDate}
                          placeholder="Registration Date"
                          readonly
                        />
                      </div>

                      <hr />

                      <h3 className="py-4 fw-bold">Partner Representative</h3>
                      {partnerData.representative && (
                        <>
                          <div className="mb-3 col-6">
                            <Input
                              label="Representative First Name"
                              name="representativeFirstName"
                              value={partnerData.representative.firstName}
                              placeholder="Representative First Name"
                              readonly
                            />
                          </div>
                          <div className="mb-3 col-6">
                            <Input
                              label="Representative Last Name"
                              name="representativeLastName"
                              value={partnerData.representative.lastName}
                              placeholder="Representative Last Name"
                              readonly
                            />
                          </div>
                          <div className="mb-3 col-6">
                            <Input
                              label="Representative Email"
                              name="representativeEmail"
                              value={partnerData.representative.email}
                              placeholder="Representative Email"
                              readonly
                            />
                          </div>
                          <div className="mb-3 col-6">
                            <Input
                              label="Representative Mobile Number"
                              name="representativeMobileNumber"
                              value={partnerData.representative.mobileNumber}
                              placeholder="Representative Mobile Number"
                              readonly
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div>Loading partner information...</div>
              )}
            </div>
          )}
          {activeTab === 'bank' && (
            <div>
              {partnerData?.bankAccount ? (
                <div className="container p-0 m-0">
                  <h3 className="fw-bold py-4">Bank</h3>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3 col-12">
                        <Input
                          label="Bank Name"
                          name="bankName"
                          value={partnerData.bankAccount.bankName}
                          placeholder="Bank Name"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-12">
                        <Input
                          label="IBAN"
                          name="iban"
                          value={partnerData.bankAccount.iban}
                          placeholder="IBAN"
                          readonly
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3 col-12">
                        <Input
                          label="Account Number"
                          name="accountNumber"
                          value={partnerData.bankAccount.accountNumber}
                          placeholder="Account Number"
                          readonly
                        />
                      </div>
                      <div className="mb-3 col-12">
                        <Input
                          label="Account Holder Name"
                          name="accountHolderName"
                          value={partnerData.bankAccount.accountHolderName}
                          placeholder="Account Holder Name"
                          readonly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div>No bank account information available.</div>
              )}
            </div>
          )}
        </div>
      </PageWithNavigation>
    </div>
  );
};

export default PartnerDetails;
